module.exports = __webpack_public_path__ + "static/media/printer.d0f4ece8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/printer.svg
// module id = 156
// module chunks = 0